import React from 'react';
import { useEffect, } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomNavbar from './Components/CustomNavbar';
import CustomFooter from './Components/CustomFooter';
import Login from './Pages/Login';
import Register from './Pages/Register';
import Home from './Pages/Home';
import './Styles/App.scss';
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider, Outlet, Navigate } from 'react-router-dom';
import Offer from './Pages/Offers/Offer';
import Offers from './Pages/Offers/Offers';
import Employer from './Pages/Employer/Employer';
import Profile from './Pages/Profile';
import CreateEmployer from './Pages/Employer/CreateEmployer';
import EmployerPanel from './Pages/Employer/EmployerPanel';
import AddOffer from './Pages/Offers/AddOffer';
import ManageOffers from './Pages/Employer/ManageOffers';
import Interresants from './Pages/Employer/Interresants';
import EmployerProfile from './Pages/Employer/EmployerProfile';
import AuthGuard from './Auth/AuthGuard';
import Apply from './Pages/Offers/Apply';


const basename = process.env.REACT_APP_BASENAME || '';


const RedirectHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirectPath = params.get('redirect');
    if (redirectPath) {
      navigate(redirectPath);
    }
  }, [navigate]);

  return null;
};

const App = () => {
  return (

    <>
      <RedirectHandler />
      <div className='App'>
        <header>
          <CustomNavbar />
        </header>
        <main className='mt-4'>
          <Outlet />
        </main>
        <footer>
          <CustomFooter />
        </footer>
      </div>
    </>

  );
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route path="" element={<Home />} />
      <Route path="/oferty" element={<Offers />}  />
      <Route path="/oferty/:name/:offerId" element={<Offer />} />
      <Route path="/logowanie" element={<Login />} />
      <Route path="/rejestracja" element={<Register />} />
      <Route path="/pracodawca" element={<Employer />} />
      <Route path="/pracodawca/utworz-podkonto" element={<CreateEmployer />} />
      <Route path="/oferty/aplikuj" element={<AuthGuard><Apply /></AuthGuard>} />
      <Route path="/pracodawca/panel" element={<AuthGuard><EmployerPanel /></AuthGuard>} />
      <Route path="/pracodawca/panel/dodaj-oferte" element={<AuthGuard><AddOffer /></AuthGuard>} />
      <Route path="/pracodawca/panel/zarzadzaj-ofertami" element={<AuthGuard><ManageOffers /></AuthGuard>} />
      <Route path="/pracodawca/panel/zainteresowani-kandydaci" element={<AuthGuard><Interresants /></AuthGuard>} />
      <Route path="/pracodawca/panel/profil" element={<AuthGuard><EmployerProfile /></AuthGuard>} />
      <Route path="/profil" element={<AuthGuard><Profile /></AuthGuard>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Route>
  ),
  {
    basename: basename
  }
);

const AppWithRouter = () => <RouterProvider router={router}></RouterProvider>;

export default AppWithRouter;

